"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AppDialogs = function AppDialogs(_ref) {
  var history = _ref.history,
      dialogs = _ref.dialogs,
      panels = _ref.panels,
      dialogProps = _ref.dialogProps;

  var handleCloseDialog = function handleCloseDialog() {
    var register = dialogProps.register;

    var _ref2 = register[history.getQuery('dialog')] || {},
        _ref2$propsForUrl = _ref2.propsForUrl,
        propsForUrl = _ref2$propsForUrl === void 0 ? {} : _ref2$propsForUrl;

    Object.entries(propsForUrl).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      history.removeQuery(key, value);
    });
    history.removeQuery('dialog');
  };

  var handleConfirmDialog = function handleConfirmDialog(data) {
    var register = dialogProps.register;
    var dialog = history.getQuery('dialog');

    if (register) {
      var props = register[dialog];

      if (props) {
        var confirm = props.callback;
        var _props$propsForUrl = props.propsForUrl,
            propsForUrl = _props$propsForUrl === void 0 ? {} : _props$propsForUrl;
        Object.entries(propsForUrl).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          history.removeQuery(key, value);
        });

        if (confirm) {
          confirm(data);
          delete register[dialog];
        }
      }
    }

    history.removeQuery('dialog');
  };

  var currentDialog = history.getQuery('dialog');
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, Object.keys(dialogs).map(function (dialog) {
    var DialogComponent = dialogs[dialog].Component;
    return /*#__PURE__*/_react["default"].createElement(DialogComponent, _extends({
      key: dialog,
      history: history,
      onClose: handleCloseDialog,
      onConfirm: handleConfirmDialog,
      panels: panels,
      open: currentDialog === dialog
    }, dialogProps));
  }));
};

AppDialogs.propTypes = {
  dialogProps: _propTypes["default"].object,
  dialogs: _propTypes["default"].object.isRequired,
  history: _propTypes["default"].object,
  panels: _propTypes["default"].array.isRequired,
  register: _propTypes["default"].object
};
var _default = AppDialogs;
exports["default"] = _default;